import React, { useState } from 'react';
import { Mui, MuiStyles } from '@osu/react-ui';
import useActionMenuItems from './useActionMenuItems';

const createClasses = (theme) => {
    return {
        icon: {
            display: 'flex',
            alignItems: 'center',
            marginRight: '1rem',
            color: theme.palette.primary.main,
        },
        menuItem: {
            padding: '.7rem 1rem .7rem 1rem',
            borderLeft: `4px solid white`,
            fontSize: "1.085em",
            '&:hover': {
                borderLeft: `4px solid ${theme.palette.primary.main}`,
            },
            minWidth: '16rem',
        },
        muiList: {
            '& .MuiMenu-list': {
                // paddingTop: 0,
                // paddingBottom: 0,
                minWwidth: '15rem',
            },
        },
    };
};

// Default to be used if no dialog component defined in menuItems.js
function EmptyDialogComponent() { return <></>; }

export default function ActionsButtonAndPopupMenu() {
    const classes = createClasses(MuiStyles.useTheme());
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuItemClicked, setMenuItemClicked] = useState(null);
    const handleClick = (event) => { setMenuAnchorEl(event.currentTarget); };
    const handleClose = () => { setMenuAnchorEl(null); };
    
    const { menuItems = [] } = useActionMenuItems();
    //const disableActionMenu = (authDetails.ADMIN !== true && (isTraining || isCurrentReviewerNotifyAdmin)) || status?.includes(APPLICATION_STATUS.CANCELLED);
    const disableActionMenu = !(menuItems.length > 0);
    if (window.location?.pathname?.includes("view")) { return <></>; }

    const DialogComponent = menuItemClicked?.component ?? EmptyDialogComponent;

    return (
        <React.Fragment>
            <Mui.Button variant="contained" color="primary" onClick={handleClick} disabled={disableActionMenu}>Actions</Mui.Button>
            
            <Mui.Menu id="applicant-menu" sx={classes.muiList} anchorEl={menuAnchorEl} keepMounted open={Boolean(menuAnchorEl)} onClose={handleClose}>
                {
                    menuItems.map((menuItem, index) => {
                        const clickIt = () => { setMenuItemClicked(menuItem); handleClose(); };
                        function fixTabNavigation(event) {
                            if (event.key !== "Tab") { return; }
                            event.preventDefault();
                            event.stopPropagation();
                            
                            const children = Array.from(event.target.parentNode.children);
                            const currentIndex = children.findIndex(ele => ele === event.target);
                            const newIndex = (currentIndex + 1) % children.length;
                            children[newIndex].focus();
                        }
                        
                        return (
                            <Mui.MenuItem key={`${menuItem.type}-${index}`} onClick={clickIt} onKeyDown={fixTabNavigation} sx={classes.menuItem} tabindex="0">
                                <Mui.Box sx={classes.icon}>{menuItem.icon}</Mui.Box>
                                
                                <Mui.Box>{menuItem.label}</Mui.Box>
                            </Mui.MenuItem>
                        );
                    })
                }
            </Mui.Menu>
            
            <DialogComponent menuItemAndClose={{ menuItem: menuItemClicked, close: () => setMenuItemClicked(null), }} />
        </React.Fragment>
    );
}